import { Documents } from '@sravni/cosago-react-library/lib/constants';

export const FORM_HINTS = {
  carModel:
    'Если нет полного совпадения — обратитесь в нашу службу заботы о клиентах, и мы обязательно поможем.  Контакты поддержки можете найти внизу страницы',
  carEnginePower:
    'Если\u00A0в\u00A0документах указано дробное значение, округлите его\u00A0до\u00A0ближайшего целого числа по\u00A0стандартным правилам',
  documentType: {
    btnText: 'Что\u00A0выбрать, если\u00A0машина не\u00A0стоит на\u00A0учёте',
    text: 'Если\u00A0автомобиль не\u00A0стоит на\u00A0учёте, то\u00A0выберите тип\u00A0документа ПТС\u00A0или\u00A0ЭПТС (для\u00A0электронных), если\u00A0стоит на\u00A0учёте\u00A0— выберите тип\u00A0СТС',
  },
  documentNumber: {
    [Documents.ECarDocumentType.PTS]: {
      text: `ПТС это документ формата А4. Не путайте его со свидетельством о регистрации`,
    },
    [Documents.ECarDocumentType.STS]: {
      text: `На лицевой стороне номер СТС пропечатан в нижней части документа красными цифрами, на оборотной находится — в верхней части`,
    },
    [Documents.ECarDocumentType.EPTS]: {
      text: `Выписку из ЭПТС можно получить в личном кабинете на сайте elpts.ru. Электронный ПТС и ПТС на бумаге — разные вещи`,
    },
  },
  identifyType: {
    [Documents.CarIdentifyType.BodyNumber]: {
      text: `Можно найти в ПТС или в СТС. Заполняйте, только если\u00A0у\u00A0вашего автомобиля нет\u00A0VIN. Вводите номер без тире и других знаков.`,
    },
    [Documents.CarIdentifyType.ChassisNumber]: {
      text: `Обычно можно найти в ПТС, СТС или инструкции автомобиля. Заполняйте, только если\u00A0у\u00A0вашего автомобиля нет\u00A0VIN. Вводите номер без тире и других знаков`,
    },
    [Documents.CarIdentifyType.VIN]: {
      text: `Идентификационный номер, указан на карточке СТС, сразу после регистрационного знака`,
    },
  },
  experienceStartDate:
    'Укажите дату выдачи первого удостоверения. Ее можно найти в прошлом полисе. Если была замена прав и вы не помните точную дату, укажите 31.12. ****, где **** - год выдачи первых прав',
  hasPreviousLicence: 'Укажите  предыдущие права, чтобы сохранить скидки за безаварийность',
  prevLicenceNumber: 'Можно найти в прошлом ОСАГО или в профиле Госуслуг',
  isDriverInsurer:
    'Тот, кто\u00A0будет обращаться в\u00A0страховую. Лучше указать собственника или\u00A0одного из\u00A0водителей',
  policyHolder:
    'Тот, кто\u00A0будет обращаться в\u00A0страховую. Лучше указать собственника или\u00A0одного из\u00A0водителей',
  registrationAddress: 'Начните вводить и выберите адрес из списка',
  notRequiredField: 'Необязательное поле',
};
